import React, {useState} from 'react';
import './styles.scss';
import {Column, Row} from '../layout';
import {useHistory} from 'react-router-dom';
import * as fonts from '../../util/fonts';
import {connect} from 'react-redux';
import colors from '../../util/colors';
import {SubMenu} from './SubMenu';
import {useVisibleMenuItems, useNavSelection} from './hooks';
import {Icons} from '../../util/icons';
import Icon from '../icon';
import {MenuItem} from './types';
import {trackMenuClick} from '../../util/appInsights';

interface Props {
  items: MenuItem[];
  buStyles: {
    primaryColor: string;
  };
  busFuncMap: {[key: string]: any};
  selectedBu: any;
  user: any;
}

function AppNavMenu({items, buStyles, busFuncMap, selectedBu, user}: Props) {
  const history = useHistory();

  const {currentPath, handleSelect, handleNavigate} = useNavSelection(history);
  const visibleItems = useVisibleMenuItems(items, busFuncMap, selectedBu, user);

  const [hoveredItem, setHoveredItem] = useState<string[] | null>(null);

  const renderMenuItem = (item: MenuItem) => {
    const isHovered =
      JSON.stringify(hoveredItem) === JSON.stringify(item.selector);
    const isActive = (item.selector as string[]).some((v: string) =>
      history.location.pathname.includes(v)
    );

    const commonStyle = {...fonts.M, ...fonts.SemiBold};

    return (
      <Column key={item.url || item.label} style={{paddingRight: '40px'}}>
        {item.url === '' ? (
          <div
            key={item.label}
            className="app-nav-menu-item"
            style={commonStyle}
            onMouseEnter={() => {
              handleSelect(item);
              setHoveredItem(item.selector as string[]);
            }}
            onMouseLeave={() => {
              setHoveredItem(null);
            }}>
            <span className="app-nav-menu-label">
              {item.label}
              {item.subItems && item.subItems.length > 0 && (
                <Icon
                  color={colors.black}
                  name={Icons.CHEVRON_DOWN}
                  className={`app-nav-menu-arrow ${isHovered ? 'rotated' : ''}`}
                />
              )}
            </span>
            {isActive && (
              <div
                className="app-nav-menu-selected-page"
                style={{
                  backgroundColor: buStyles?.primaryColor || colors.blue,
                }}
              />
            )}
            {isHovered && (
              <SubMenu
                item={item}
                busFuncMap={busFuncMap}
                selectedBu={selectedBu?.buId}
                handleNavigate={handleNavigate}
              />
            )}
          </div>
        ) : (
          <div
            key={item.label}
            className="app-nav-menu-item"
            style={commonStyle}
            onClick={() => {
              trackMenuClick(item.label, item.url, {
                menuLevel: 'root',
                funct: item.funct,
                buId: selectedBu?.buId,
              });
              handleNavigate(item.url, item.selector as string[]);
            }}
            onMouseOver={() => handleSelect(item)}>
            {item.label}
            {isActive && (
              <div
                className="app-nav-menu-selected-page"
                style={{
                  backgroundColor: buStyles?.primaryColor || colors.blue,
                }}
              />
            )}
            <div className="app-nav-menu-selected-page-label" />
          </div>
        )}
      </Column>
    );
  };

  return (
    <Row key={currentPath} className="app-nav-menu-row">
      {visibleItems.map(renderMenuItem)}
    </Row>
  );
}

const mapStateToProps = (store: any) => ({
  buStyles: store.globalStyles.value,
  busFuncMap: store.busFuncMap.value,
  selectedBu: store.selectedBu.value,
  user: store.user.value,
});

export default connect(mapStateToProps)(AppNavMenu);
